<!--
 * @Description:
 * @Author: Lynn Qin
 * @Date: 2021-04-12 16:25:13
 * @LastEditTime: 2022-05-07 14:50:13
-->
<template lang="pug">
    .pgc-header
        .left
            img(src="@/assets/logo-berich.png")
        .right
            el-dropdown(trigger="click" @command="changeLang")
                span(class="el-dropdown-link") {{langItem[0].name}}
                    i(class="el-icon-arrow-down el-icon--right" style="margin-right: 30px")
                el-dropdown-menu(slot="dropdown")
                    el-dropdown-item(v-for="(item,index) in langList.filter(item => item.langType !== langType)" :key="index" :command="item.langType") {{item.name}}
            img.avatar-img(:src="$store.getters['user/avatar']" alt="avatar")
            span.pgc-header__name {{$store.getters['user/nickname']}}
            el-dropdown(@command="handleCommand")
                span(class="el-dropdown-link")
                    i.el-icon-caret-bottom
                el-dropdown-menu(slot="dropdown" style="padding: 0")
                    el-dropdown-item(style="height: 32px; line-height: 32px;padding-left: 12px;font-size: 12px" command="a") {{$t('changePassword')}}
                    el-dropdown-item(style="height: 32px; line-height: 32px;padding-left: 12px;font-size: 12px" command="b") {{$t('Logout')}}
        change-password-dialog(v-model="dialogVisiblePassWord" v-if="dialogVisiblePassWord")
</template>

<script>
import { Dropdown, DropdownMenu, DropdownItem } from 'element-ui'
import { exitlogin } from '@/utils/login'
import { myStorage } from '@/utils/storage'

import ChangePasswordDialog from '@/components/change-password-dialog'
import { RIM } from '@/utils/rong-im'

export default {
    name: 'pgc-header',
    components: {
        [Dropdown.name]: Dropdown,
        [DropdownItem.name]: DropdownItem,
        [DropdownMenu.name]: DropdownMenu,
        ChangePasswordDialog
    },
    data() {
        const langType = this.$env.langType
        return {
            langType,
            langList: [
                {
                    name: '简',
                    img: require('@/assets/images/lang-cn.png'),
                    langType: 1
                },
                {
                    name: '繁',
                    img: require('@/assets/images/lang-hk.png'),
                    langType: 2
                },
                {
                    name: 'ENG',
                    img: require('@/assets/images/lang-en.png'),
                    langType: 3
                }
            ],
            dialogVisiblePassWord: false
        }
    },
    computed: {
        langItem() {
            return this.langList.filter(item => item.langType === this.langType)
        }
    },
    methods: {
        changeLang(val) {
            let langMap = new Map([[1, 'zh-cn'], [2, 'zh-hk'], [3, 'en']])
            let ElLang = langMap.get(this.langType)
            myStorage.set('pgcLangType', val)
            window.location.href = window.location.href.replace(ElLang,langMap.get(val))
        },
        handleCommand(command) {
            switch (command) {
                case 'a':
                    this.changePasswordFn()
                    break;
                case 'b':
                    this.logout()
                    break;
                default:
                    break;
            }
        },
        changePasswordFn() {
            this.dialogVisiblePassWord = true
        },
        logout() {
            this.$confirm(this.$t('Confirmlogout')).then(() => {
                exitlogin()
                RIM.disconnect()
            }).catch(() => {
            })
        }
    }
}
</script>

<style scoped lang="scss">
.pgc-header {
    color: #fff;
    font-size: 12px;
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    padding-right: 20px;
    justify-content: space-between;
    background: $--color-primary;
    box-sizing: border-box;
    .left{
        padding-left: 70px;
        img{
            width: 102px;
            height: 21px;
        }
    }
    .avatar-img{
        width: 20px;
        height: 20px;
        border-radius: 50%;
        // filter: hue-rotate(180deg);
    }
    .lang-img{
        width: 20px;
        height: 20px;
        padding-right: 10px;
    }
    &__name{
        padding:0 0px 0 10px
    }
    .el-dropdown-link-left{
        padding-right: 20px;
    }
    .el-dropdown-link{
        color: #fff;
        padding-left: 10px;
    }
    ::v-deep .el-dropdown-menu__item{
        padding-left: 20px !important;
    }
    .el-icon-caret-bottom{
        color: #fff
    }
}
</style>
